const getStoredToken = (storageName, key) => {
  try {
    const storage = typeof window !== 'undefined' ? window[storageName] : globalThis?.[storageName];
    return storage?.getItem?.(key) || '';
  } catch {
    return '';
  }
};

export const getMemberRequestToken = () => (
  getStoredToken('localStorage', 'access_token')
  || getStoredToken('sessionStorage', 'access_token')
  || getStoredToken('localStorage', 'content_admin_token')
);